export default {
  belgium_france: {
    name: "Belgique - France",
    address: "Chaussée de Marche 496 boîte 21",
    zip: '5101',
    city: 'Namur (Erpent)',
    tel: '+32 (0) 81 30 64 46',
    email: 'info@secundo.com'
  },
  costa_blanca: {
    name: "Costa Blanca",
    address: "Avenida de las Habaneras 81 Bajo 4<sup>a</sup><br>Edificio Mariblanca IX",
    zip: '03182',
    city: 'Torrevieja',
    tel: '+34 664 271 801',
    email: 'info@secundo.com'
  },
  costa_del_sol: {
    name: "Costa del Sol",
    address: "Bulevard Principe de Alfonso de Hohenloe<br>CC El Capricho - Oficina 11",
    zip: '29602',
    city: 'Marbella',
    tel: '+34 617 271 462',
    email: 'info@secundo.com'
  }
};


// WEBPACK FOOTER //
// ./src/data/regions_contacts.js